import React from 'react';

import AccountsReceivableComponent from '../../../components/public/AccountsReceivable';

class AccountsReceivable extends React.PureComponent {
  render() {
    return (
      <AccountsReceivableComponent />
    );
  }
}

export default AccountsReceivable;